import { Component, Input, inject } from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import {LanguageSelectionComponent} from "../language-selection/language-selection.component";
import {CustomerBrandingLogoComponent} from "../customer-branding-logo/customer-branding-logo.component";
import {ProgressIndicatorComponent} from "../progress-indicator/progress-indicator.component";
import {Router} from "@angular/router";
import {LocaleService} from "../../../locale/locale.service";
import {NavigationService} from "../../../services/navigation.service";

@Component({
  selector: 'app-header',
  imports: [
    LanguageSelectionComponent,
    CustomerBrandingLogoComponent,
    ProgressIndicatorComponent,
    NgOptimizedImage
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  private router = inject(Router);
  private locale = inject(LocaleService);
  private navigationService = inject(NavigationService);


  @Input()
  isWelcome:boolean = false;
  @Input()
  progress:number = 1;

  @Input()
  title:string = '';

  @Input()
  showProgressIndicator:boolean = true;

  @Input()
  showClose = true;
  @Input()
  useWhiteFontColor:boolean = false;
  back() {
    this.navigationService.navigateBack();
  }
  cancel(){
    const confirmed = window.confirm(this.locale.currentTranslation.cancelText);
    if (confirmed) {
      this.router.navigate(['']);
    }
  }

}
